import { render, staticRenderFns } from "./setDiffculty2.vue?vue&type=template&id=62b5f866&scoped=true&"
import script from "./setDiffculty2.vue?vue&type=script&lang=js&"
export * from "./setDiffculty2.vue?vue&type=script&lang=js&"
import style0 from "./setDiffculty2.vue?vue&type=style&index=0&id=62b5f866&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5f866",
  null
  
)

export default component.exports